
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-training-calander',
  templateUrl: './training-calander.component.html',
  styleUrl: './training-calander.component.scss'
})
export class TrainingCalanderComponent implements OnInit , OnChanges{
  daysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  calendarData: any[] = [];
  yearCalendarData: any[] = []; // Array to hold all 12 months
  currentDate: Date = new Date();
  currentYear: number = new Date().getFullYear();
  apiData : any = []
  modalData : any
  showDilogue  = false
  isLoading: boolean = false;
  zoomedMonthIndex: number | null = null; // Track which month is zoomed
  @Input() training_type !: string 
  @Input() userProfileFlag !: boolean 
  @Input() query !:any
  

  @Output() showTraining: EventEmitter<any> = new EventEmitter();

  constructor(private dataService: DataService,private router: Router,) { }

  ngOnInit(): void {
    this.currentYear = this.currentDate.getFullYear();
    this.isLoading = true;
    this.getYearData().then(()=>{
      this.generateYearCalendar();
      this.isLoading = false;
    })
  }


  ngOnChanges() {
    this.currentYear = this.currentDate.getFullYear();
    this.isLoading = true;
    this.getYearData().then(()=>{
      this.generateYearCalendar();
      this.isLoading = false;
    })
  }


  showTrainingDetail(req:any){
    this.showTraining.emit(req);
    
    // Extract training ID based on data structure
    // Try multiple possible locations where training ID might be stored
    let trainingId = null;
    
    // Check all possible locations for training ID
    if (req.trainingId) {
      // trainingId might be a string or an object with _id
      trainingId = typeof req.trainingId === 'string' ? req.trainingId : (req.trainingId._id || req.trainingId);
    } else if (req.trainingDetails && req.trainingDetails._id) {
      trainingId = req.trainingDetails._id;
    } else if (req._id) {
      trainingId = typeof req._id === 'string' ? req._id : (req._id._id || req._id);
    } else if (req.request_id && req.request_id.trainingId) {
      // For user profile, might be nested in request_id
      trainingId = typeof req.request_id.trainingId === 'string' 
        ? req.request_id.trainingId 
        : (req.request_id.trainingId._id || req.request_id.trainingId);
    } else if (req.request_id && req.request_id._id) {
      trainingId = req.request_id._id;
    }
    
    if (!trainingId) {
      console.error('Training ID not found in data:', req);
      console.log('Available keys:', Object.keys(req));
      return;
    }
    
    // Close modal before navigating
    this.showDilogue = false;
    
    let params = {
      _id : trainingId,
      flag : 'VIEW', 
      from : this.userProfileFlag ? 'Attendee' : 'SBC' 
    }
    this.navigateToTrainingPage(params)
  }

  navigateToTrainingPage(params:any) {
    const trainingId = params._id;
    this.router.navigate(['/training/training-page', trainingId], { queryParams: params } );
  }

  generateCalendarDays(month: number, year: number): any[] {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysOfWeekCopy = this.daysOfWeek.slice(this.daysOfWeek.indexOf('Sunday')).concat(this.daysOfWeek.slice(0, this.daysOfWeek.indexOf('Sunday')));
  
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const startingDay = (firstDayOfMonth - daysOfWeekCopy.indexOf('Sunday') + 7) % 7;
  
    const monthCalendarData: any[] = [];
    let currentRow: any[] = [];
    
    for (let day = 1; day <= daysInMonth + startingDay; day++) {
      const dayNumber = day - startingDay;
  
      const dayData = this.apiData.find((data:any) => {
        return data._id.year === year && data._id.month === month + 1 && data._id.day === dayNumber;
      });
  
      currentRow.push({
        _id: { year: year, month: month + 1, day: dayNumber },
        data: dayData ? dayData.data : []
      });
  
      if (currentRow.length === 7) {
        monthCalendarData.push(currentRow);
        currentRow = [];
      }
    }
  
    // Add the last row if it's not complete
    if (currentRow.length > 0) {
      monthCalendarData.push(currentRow);
    }
    
    return monthCalendarData;
  }

  generateYearCalendar(): void {
    this.yearCalendarData = [];
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                        'July', 'August', 'September', 'October', 'November', 'December'];
    
    for (let month = 0; month < 12; month++) {
      const monthData = {
        monthIndex: month,
        monthName: monthNames[month], // Use English name, translator pipe will handle translation
        calendarData: this.generateCalendarDays(month, this.currentYear)
      };
      this.yearCalendarData.push(monthData);
    }
  }

  formatMonth(): string {
    return this.currentDate.toLocaleDateString('en-US', { month: 'long' });
  }

  formatYear(): string {
    return this.currentYear.toString();
  }

  nextYear(): void {
    this.currentYear++;
    this.isLoading = true;
    this.getYearData().then(()=>{
      this.generateYearCalendar();
      this.isLoading = false;
    })
  }

  prevYear(): void {
    this.currentYear--;
    this.isLoading = true;
    this.getYearData().then(()=>{
      this.generateYearCalendar();
      this.isLoading = false;
    })
  }

  getMonthHeaderColor(index: number): string {
    const colors = ['blue', 'purple', 'sbc'];
    return colors[index % 3];
  }

  toggleZoomMonth(monthIndex: number): void {
    if (this.zoomedMonthIndex === monthIndex) {
      this.zoomedMonthIndex = null; // Close zoomed view
    } else {
      this.zoomedMonthIndex = monthIndex; // Zoom into this month
    }
  }

  closeZoomedMonth(): void {
    this.zoomedMonthIndex = null;
  }

  async getData(){
    try {
      let currentDate = this.currentDate
      currentDate.setDate(1)
      currentDate.setHours(0,0,0,0)
      const lastDayOfMonth = this.getLastDayOfMonth(this.currentDate);
      lastDayOfMonth.setHours(0,0,0,0);

      let query : any = {
        start_date : currentDate,
        end_date : lastDayOfMonth,
        type : this.training_type == 'MONTHLY' ? 'Unified session' : this.training_type
      }

      if(this.query || this.query != null){
        query = {...query , ...this.query}
      }

      let url = 'training-req/get/calender'
      if(this.userProfileFlag){
        url = 'course/training-calender'
        query.uid = localStorage.getItem('uid')
      }

      let res = await this.dataService.postData(url, query);

      if(res.error) return;
      this.apiData = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  async getYearData(){
    try {
      // Get data for entire year
      const startDate = new Date(this.currentYear, 0, 1); // January 1st
      startDate.setHours(0,0,0,0);
      const endDate = new Date(this.currentYear, 11, 31); // December 31st
      endDate.setHours(23,59,59,999);

      let query : any = {
        start_date : startDate,
        end_date : endDate,
        type : this.training_type == 'MONTHLY' ? 'Unified session' : this.training_type
      }

      if(this.query || this.query != null){
        query = {...query , ...this.query}
      }

      let url = 'training-req/get/calender'
      if(this.userProfileFlag){
        url = 'course/training-calender'
        query.uid = localStorage.getItem('uid')
      }

      let res = await this.dataService.postData(url, query);

      if(res.error) return;
      this.apiData = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  getLastDayOfMonth(date: Date): Date {
    // Create a new date based on the input date
    const lastDay = new Date(date);
  
    // Set the date to the last day of the month
    lastDay.setMonth(lastDay.getMonth() + 1, 0);
  
    return lastDay;
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTraining(id:any){
    //emmiter 
  }

  getModalData(modalData:any){
    this.modalData = modalData
    
    if(modalData.data.length <=0) return
    this.showDilogue= true
      modalData?.data?.forEach((item: any) => {
        if (item.request_id.status = 'COMPLETED') {
          let allsessions = item.session.filter((e: any) => !e.sessionId?.video_url)
          let value = this.calculateAttendancePercentage(allsessions)

          if (this.calculateAttendancePercentage(allsessions) < 70) {
            item.request_id.status = 'ATTENDANCE_SHORT'
            // this.cardData.splice(this.cardData.indexOf(item._id), 1);
          }
        }
      });

      this.modalData
      

  }

  calculateAttendancePercentage(sessions: any) {

    let uid = localStorage.getItem('uid');

    // Filter sessions where the attendee is present
    const attendedSessions = sessions.filter((session: any) => session?.attendees?.includes(uid));

    // Calculate total sessions and attended sessions count
    const totalSessions = sessions.length;
    const attendedSessionsCount = attendedSessions.length;

    // Calculate attendance percentage
    const attendancePercentage = (attendedSessionsCount / totalSessions) * 100;

    return attendancePercentage;
  }

  getTrainingIcon(training: any): string {
    // Return different icon classes based on training type/status
    if (training.status === 'PUBLISHED' || training.request_id?.status === 'PUBLISHED') {
      return 'pi pi-circle-fill training-icon-green';
    } else if (training.status === 'COMPLETED' || training.request_id?.status === 'COMPLETED') {
      return 'pi pi-check-circle training-icon-teal';
    } else if (training.status === 'PENDING' || training.request_id?.status === 'PENDING') {
      return 'pi pi-clock training-icon-yellow';
    }
    return 'pi pi-circle training-icon-blue';
  }

}
